module.exports = __webpack_public_path__ + "img/crewpages_logo_text_dark.ab461a5f.svg";